import { render, staticRenderFns } from "./chartOTP.vue?vue&type=template&id=5829d3b7&"
import script from "./chartOTP.vue?vue&type=script&lang=js&"
export * from "./chartOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QAvatar} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QAvatar}, component.options.components || {})
